import { v4 as uuid } from "uuid";
import {
  Availability,
  ConditionsLogicOperator,
  TriggerDescription_TriggerRetrySupport,
} from "@smartsuite/automation-engine-api";
import type { TriggerMerger } from ".";
import type { TriggerCandidate } from "../../../../types/candidate";
import type {
  IntegrationState,
  TriggerDescription,
} from "@smartsuite/automation-engine-api";

export const mergeReferenceIds =
  (integrationId: string, triggerId: string): TriggerMerger =>
  () => ({
    hash: uuid(),
    triggerReference: {
      integrationId,
      triggerId,
    },
    description: {
      triggerId: "",
      label: "",
      subLabel: "",
      authenticationId: [],
      inputs: [],
      outputs: [],
      conditionFields: [],
      triggerRetrySupport:
        TriggerDescription_TriggerRetrySupport.RETRY_NOT_SUPPORTED,
    },
    credentialId: "",
    inputs: [],
    conditions: {
      operator: ConditionsLogicOperator.OPERATOR_AND,
      group: [],
    },
  });

export const mergeCredentialId =
  (credentialId: string): TriggerMerger =>
  (trigger: TriggerCandidate) =>
    trigger.credentialId === credentialId
      ? trigger
      : {
          ...trigger,
          credentialId,
        };

export const mergeTriggerDescription =
  (description: TriggerDescription): TriggerMerger =>
  (trigger: TriggerCandidate) => ({ ...trigger, description });

export const mergeTriggerDisabledError =
  (description: TriggerDescription): TriggerMerger =>
  (trigger: TriggerCandidate) => {
    return {
      ...trigger,
      description,
      triggerDisabled:
        description.info?.availability === Availability.AVAILABILITY_DISABLED,
    };
  };

export const mergeTriggerIntegrationDisabledError =
  (
    description: TriggerDescription,
    isIntegrationDisabled?: boolean,
  ): TriggerMerger =>
  (trigger: TriggerCandidate) => {
    return {
      ...trigger,
      description,
      integrationDisabled: isIntegrationDisabled,
    };
  };

// State the integration gave a draft trigger, such as its webhook id, which it
// settles from when the automation is saved.
export const mergeIntegrationState =
  (integrationState: IntegrationState | undefined): TriggerMerger =>
  (trigger: TriggerCandidate) =>
    integrationState === undefined ? trigger : { ...trigger, integrationState };
